import { useMemo } from 'react';
import { createTemplateSx } from '../styles/templateLayout';
import useTemplateTheme from './useTemplateTheme';

export default function useTemplateSx() {
  const themeTokens = useTemplateTheme();

  return useMemo(
    () => createTemplateSx({ accent: themeTokens.accent, shadows: themeTokens.shadows }),
    [themeTokens.accent, themeTokens.shadows]
  );
}
